import React, { PureComponent } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import { withCookies } from 'react-cookie';
import MoreFromHlf from '@client/containers/moreFromHlf/MoreFromHlf';
import ProgressBar from '@client/components/progressBar/ProgressBar';
import { formatNumber } from '@client/shared/utils/jsUtils/jsUtils';
import SocialMediaSharing from '@client/components/socialMediaSharing/SocialMediaSharing';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { selectServerRequestInfo } from '@client/redux/requestState/requestStateReducer';
import {
  loadEventPageData,
  selectEvent,
} from '@client/pages/eventPage/duckEventPage';
import ReactLink from '@client/components/reactLink/ReactLink';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import Image from '@client/components/image/Image';
import Markdown from '@client/components/markdown/Markdown';
import {
  setCookie,
  valueOrEmptyStr,
  valueOrZero,
} from '@client/shared/utils/utils/utils';
import FundraiserCard from '@client/containers/fundraiserCard/FundraiserCard';
import { selectFundraiser } from '@client/redux/fundraiser/fundraiserSelectors';
import FeaturedCard from '@client/containers/featuredCard/FeaturedCard';
import SimpleListing from '@client/components/listings/simpleListing/SimpleListing';
import ArticleCard from '@client/containers/articleCard/ArticleCard';
import { Auth0Context } from '@client/helperComponents/react-auth0-spa';
import { removeQueryStringParams } from '@client/helpers/removeQueryStringParams';
import styles from './eventPage.scss';

const FundraiserListing = ({ className, list }) => (
  <div
    className={`${styleHelper.alignmentContainer}${
      className ? ` ${className}` : ''
    }`}
  >
    <div className={styleHelper.grid13}>
      {list &&
        list.map((fundraiser) => {
          return (
            <FundraiserCard
              key={getIn(fundraiser, 'id')}
              fundraiser={fundraiser}
              showStatsInsteadOfDescription={true}
            />
          );
        })}
    </div>
  </div>
);

class EventPage extends PureComponent {
  static contextType = Auth0Context;

  constructor(props) {
    super(props);
  }
  static loadData(dispatch, urlLocation, matchParams) {
    const eventName = removeQueryStringParams(matchParams.eventName);
    return dispatch(loadEventPageData(eventName));
  }

  componentDidMount() {
    EventPage.loadData(
      this.props.dispatch,
      this.props.location,
      this.props.match.params
    );
  }

  getShareUrl = () => {
    const { location, serverRequestInfo } = this.props;

    return getIn(serverRequestInfo, 'origin') + location.pathname;
  };

  getCreateFundraiserUrl = () => {
    const slug = valueOrEmptyStr(getIn(this.props.pageData, 'slug'));
    const fundraiserTypeId = getIn(
      this.props.pageData,
      'fundraiserType',
      'fields',
      'id'
    );

    return `/skapa/insamling?type=${fundraiserTypeId}&eventName=${slug}`;
  };

  handleAuthRouteChange = (event) => {
    if (!this.context.isAuthenticated) {
      event.preventDefault();
      event.stopPropagation();
      const slug = valueOrEmptyStr(getIn(this.props.pageData, 'slug'));
      const fundraiserTypeId = getIn(
        this.props.pageData,
        'fundraiserType',
        'fields',
        'id'
      );

      const url = `/skapa/insamling?type=${fundraiserTypeId}&eventName=${slug}`;

      this.context.loginWithRedirect({
        appState: { targetUrl: url },
      });
    }
  };

  getImage = (pageData, fileImageProp, fallBackImgProp) => {
    const eventImageFileUrl = getIn(
      pageData,
      fileImageProp,
      'fields',
      'file',
      'url'
    );

    return eventImageFileUrl
      ? eventImageFileUrl
      : getIn(pageData, fallBackImgProp);
  };

  render() {
    const { pageData, fundraiser } = this.props;
    const slug = getIn(pageData, 'slug');

    const eventHeading = getIn(pageData, 'eventTitle');
    const eventName = valueOrEmptyStr(getIn(pageData, 'eventName'));
    const totalDonations = valueOrZero(getIn(fundraiser, 'totalDonatedAmount'));
    const target = getIn(pageData, 'targetAmount');
    const percentage =
      target > 0 ? Math.round((totalDonations * 100) / target) : 0;

    const hasCompetition =
      !!getIn(pageData, 'competitionTitle') &&
      !!getIn(pageData, 'competitionText');

    const fundraisers = getIn(fundraiser, 'results');
    const fundraisersSortedByAmountDonated =
      fundraisers &&
      fundraisers
        .sortBy((thisFundraiser) => getIn(thisFundraiser, 'amountDonated'))
        .reverse();

    const numberOfFundraisers = getIn(fundraiser, 'totalCount');

    const articles = getIn(pageData, 'articles')
      ? getIn(pageData, 'articles').map((each) => getIn(each, 'fields'))
      : undefined;

    const eventImg = this.getImage(pageData, 'eventImage', 'eventImageUrl');
    const competitionImg = this.getImage(
      pageData,
      'competitionImage',
      'competitionImageUrl'
    );

    return (
      <div className={styleHelper.flexCol}>
        <div className={`${styleHelper.contentContainer} ${styles.eventPage}`}>
          <div className={`${styles.headerContainer}`}>
            {eventHeading && (
              <div className={styles.centerContainer}>
                <h1
                  className={`${styleHelper.titleLgPrimary} ${styles.imageText} ${styles.imageTitle}`}
                >
                  {valueOrEmptyStr(eventHeading)}
                </h1>
              </div>
            )}
            {eventImg && <Image className={styles.eventImage} src={eventImg} />}
          </div>
          <div
            className={`${styleHelper.layoutMobileAndTabletSidePadding} ${styles.eventStatistics} ${styleHelper.flexCol}`}
          >
            <h4 className={`${styleHelper.titleMdPrimary} ${styles.donated}`}>
              {formatNumber(totalDonations)} kronor
            </h4>
            <div
              className={`${styleHelper.titleSmPrimary} ${styles.percentage}`}
            >
              {percentage}%
            </div>
            <ProgressBar className={styles.progress} progress={percentage} />
            <div className={`${styles.target} ${styleHelper.titleMdPrimary}`}>
              Mål: {formatNumber(valueOrZero(getIn(pageData, 'targetAmount')))}{' '}
              kronor
            </div>
          </div>
          <div className={`${styleHelper.layoutMobileAndTabletSidePadding}`}>
            <div className={`${styleHelper.grid12} ${styles.eventInformation}`}>
              <div
                className={`${styleHelper.flexCol} ${styles.descriptionContainer}`}
              >
                <div className={styles.eventDescription}>
                  <Markdown
                    value={valueOrEmptyStr(getIn(pageData, 'eventDescription'))}
                  />
                </div>
                <div className={styleHelper.flexRow}>
                  <ReactLink
                    className={`${styleHelper.btnPrimaryMd}`}
                    to={this.getCreateFundraiserUrl()}
                    onClick={this.handleAuthRouteChange}
                  >
                    Starta insamling
                  </ReactLink>
                </div>
              </div>
              <div className={styles.sharingBoxContainer}>
                <div className={styles.sharingBox}>
                  <p className={styleHelper.titleSmPrimary}>
                    Hjälp oss nå målet. Dela detta evenemang med dina vänner!
                  </p>
                  <SocialMediaSharing
                    url={this.getShareUrl() || ''}
                    hashtag="hjärtlungfonden"
                    via="hjartlungfonden"
                    title={eventName}
                    hideEmail={true}
                  />
                </div>
              </div>
            </div>
          </div>
          {hasCompetition && (
            <FeaturedCard
              title={getIn(pageData, 'competitionTitle')}
              subTitle={getIn(pageData, 'competitionSubTitle')}
              imageUrl={competitionImg}
              text={getIn(pageData, 'competitionText')}
              to={this.getCreateFundraiserUrl()}
              asterisk={getIn(pageData, 'competitionAsteriskText')}
              onClick={this.handleAuthRouteChange}
            />
          )}
          {articles && (
            <div className={`${styles.articlesContainer}`}>
              <div className={styleHelper.alignmentContainer}>
                <SimpleListing
                  className={styleHelper.grid13}
                  list={articles}
                  ListItemComponent={ArticleCard}
                  listItemProps={{
                    itemObjName: 'article',
                    fluidImage: true,
                  }}
                />
              </div>
            </div>
          )}
          {fundraisersSortedByAmountDonated && numberOfFundraisers > 0 && (
            <div className={`${styles.fundraisers}`}>
              <h3
                className={`${styleHelper.titleMdPrimary} ${styles.title} ${styleHelper.layoutMobileSidePadding}`}
              >
                Insamlingar för {eventName}
              </h3>
              <FundraiserListing
                className={styles.fundraiserListingProp}
                list={fundraisersSortedByAmountDonated.slice(0, 3)}
              />
              <ReactLink
                className={`${styles.showMoreFundraisersLink}`}
                to={`/?eventName=${slug}#listing`}
              >
                Se fler insamlingar för {eventName}
              </ReactLink>
            </div>
          )}
        </div>
        <MoreFromHlf className={styles.section} />
      </div>
    );
  }
}

EventPage.propTypes = {
  location: PropTypes.object,
  serverRequestInfo: ImmutablePropTypes.map,
  dispatch: PropTypes.func,
  pageData: ImmutablePropTypes.map,
  fundraiser: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    serverRequestInfo: selectServerRequestInfo(state),
    pageData: selectEvent(state),
    fundraiser: selectFundraiser(state),
  };
}

export default withRouter(connect(mapStateToProps)(withCookies(EventPage)));
